export default "__VITE_ASSET__DqJxRCeO__"